import script from "./AverageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AverageView.vue?vue&type=script&lang=ts&setup=true"

import "./AverageView.vue?vue&type=style&index=0&id=0e1ac03c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1ac03c"]])

export default __exports__